export default function alerts(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                alert: action.alert,
            }
        default:
            return state;
    }
}
